import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxDropdown } from "@axess/limestone";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";

@ModuleName("ShoppingCartEntryRetail")
export class ShoppingCartEntryRetail implements AxInit {
    private quantitySelections: AxDropdown = new AxDropdown();
    constructor(private _axLoading = new AxLoading()) { }

    AxInit(init): void {
    }

    initDropDown() {
        this.quantitySelections.init('.cart-position__retail .ax-dropdown',
            {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent, value) => {
                    this.switchQuantity($parent, value as string);
                }
            });
    }

    switchQuantity($parent: JQuery<HTMLElement>, value: string) {
        let cartEntryID = parseInt($parent.attr('data-targetID'));

        let quantity = parseInt(value);
        let orgQuantity = parseInt($parent.find('.retail__quantitySelection').html());

        if (quantity !== orgQuantity) {
            this._axLoading.ShowLoadingIndicator($(`.cart-position__retail[data-targetID=${cartEntryID}]`)[0]);
            AxessViewer.loadPartialView('/SCRetail/UpdateQuantity',
                {
                    cartEntryID: cartEntryID,
                    quantity: quantity
                },
                x => {
                    if (x.success) {
                        $parent.find('.retail__quantitySelection').html(value);
                        $('#total_price_holder').html(x.total);
                        $(`.retail__subtotal[data-targetID=${cartEntryID}]`).html(x.groupTotal);
                        $(`.cart_portlet_prodType_5-subtotal`).html(x.subTotal);
                    }
                    this._axLoading.HideLoadingIndicator($(`.cart-position__retail[data-targetID=${cartEntryID}]`)[0]);
                },
                {});
        }
    }
}